import { useCallback, useRef } from 'react';
import type React from 'react';

import { TypedTranslate } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';
import { FakeLink, Link } from '@change-corgi/design-system-legacy/components/actions';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { Waypoint } from '#src/app/shared/components/scroll';

import { usePetitionDetails } from '../../../hooks/petitionDetails';
import type { TipCardConfig } from '../types';

export const TipCard: React.FC<{ tip: TipCardConfig }> = ({ tip }) => {
	const { id } = usePetitionDetails();
	const track = useTracking();
	const viewTracked = useRef(false);
	const trackView = useCallback(() => {
		if (viewTracked.current) return;
		void track('petition_strength_card_view', {
			petition_id: id,
			card: tip.type,
		});
		viewTracked.current = true;
	}, [id, track, tip.type, viewTracked]);

	return (
		<Flex
			p={24}
			sx={{
				background: 'background',
				borderRadius: 'standard',
				flexDirection: 'column',
				gap: 8,
				height: '100%',
				width: 325,
			}}
		>
			<Text as="p" size="small" fontWeight="bold">
				<TypedTranslate value={tip.title} />
			</Text>
			<Text as="p" size="small" color="neutral-grey600">
				<TypedTranslate value={tip.body} />
			</Text>
			<Text as="p" size="small">
				{tip.url ? (
					<Link to={tip.url} onClick={tip.onClick} preventScrollReset variant="primary">
						<TypedTranslate value={tip.primaryActionText} />
					</Link>
				) : (
					<FakeLink onClick={tip.onClick}>
						<TypedTranslate value={tip.primaryActionText} />
					</FakeLink>
				)}
			</Text>
			<Flex>
				<Box sx={{ width: '100%' }} />
				<Waypoint horizontal onEnter={trackView} />
			</Flex>
		</Flex>
	);
};
